/**
 * Official third-party product profiles (G2, Trustpilot).
 * Single source of truth for footer, hero trust strip, blog footers, and AI-facing copy.
 */
export const G2_PRIME_DOCUMENT_SIGN_URL = 'https://www.g2.com/products/prime-document-sign/'
export const TRUSTPILOT_PRIME_DOCUMENT_SIGN_URL = 'https://au.trustpilot.com/review/primedocumentsign.com'

/** Google Business Profile share link (reviews / write a review). */
export const GOOGLE_BUSINESS_REVIEW_SHARE_URL =
  'https://share.google/u791Oa6XwvwU0fizT'
